import { useCurrentSubscription } from '@/hooks/useSubscription';
import Badge from '@/components/common/Badge';

export default function CurrentPlan() {
  const { data: subscription, isLoading } = useCurrentSubscription();

  if (isLoading || !subscription) return null;

  const tierNames: Record<string, string> = {
    free: 'Free',
    indie: 'Indie',
    pro: 'Pro',
  };

  const tierDescriptions: Record<string, string> = {
    free: 'Get started with limited Moves and messages',
    indie: 'For independent creators growing their audience',
    pro: 'For professionals who need maximum output',
  };

  const statusVariant = (() => {
    switch (subscription.status) {
      case 'active':
        return 'success' as const;
      case 'cancelling':
        return 'warning' as const;
      case 'past_due':
        return 'error' as const;
      default:
        return 'warning' as const;
    }
  })();

  const statusLabel = (() => {
    switch (subscription.status) {
      case 'active':
        return 'Active';
      case 'cancelling':
        return 'Cancelling';
      case 'past_due':
        return 'Past Due';
      default:
        return subscription.status;
    }
  })();

  return (
    <section className="rounded-lg border border-neutral-200 bg-primary-10 p-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-lg font-semibold text-neutral-900">Current Plan</h2>
          <p className="mt-1 text-2xl font-bold text-primary-600">
            {tierNames[subscription.tier] || subscription.tier}
          </p>
          <p className="mt-1 text-sm text-neutral-500">
            {tierDescriptions[subscription.tier] || ''}
          </p>
        </div>
        <Badge variant={statusVariant}>
          {statusLabel}
        </Badge>
      </div>

      {subscription.status === 'cancelling' && subscription.expires_at && (
        <p className="mt-3 text-sm text-warning-600">
          Your plan will downgrade to Free on{' '}
          {new Date(subscription.expires_at).toLocaleDateString()}
        </p>
      )}

      {subscription.status === 'active' && subscription.expires_at && subscription.tier !== 'free' && (
        <p className="mt-2 text-sm text-neutral-500">
          Renews on {new Date(subscription.expires_at).toLocaleDateString()}
        </p>
      )}
    </section>
  );
}
